export default __webpack_public_path__ + "static/media/qualifications.bfbb28d4.jpg";